// mds-dojo — dojo/ready. Runs a callback once the DOM is ready, honoring an
// optional numeric priority (lower runs earlier). Supports the dojo call shapes:
//   ready(fn) | ready(priority, fn) | ready(priority, context, methodName)

interface Entry { priority: number; fn: () => void; }
let queue: Entry[] = [];
let fired = false;

function flush() {
  if (fired) { return; }
  fired = true;
  queue.sort((a, b) => a.priority - b.priority);
  const q = queue;
  queue = [];
  for (const e of q) { e.fn(); }
}

function domReady(): boolean {
  return document.readyState === 'interactive' || document.readyState === 'complete';
}

if (typeof document !== 'undefined') {
  if (domReady()) {
    // Defer to a microtask so registrations made synchronously after import land first.
    Promise.resolve().then(flush);
  } else {
    document.addEventListener('DOMContentLoaded', flush, false);
  }
}

export default function ready(priority: any, context?: any, callback?: any): void {
  let prio = 1000;
  let fn: () => void;
  if (typeof priority === 'function') {
    fn = priority;
  } else {
    prio = priority;
    if (typeof context === 'function') {
      fn = context;
    } else {
      fn = () => context[callback]();
    }
  }
  if (fired) { fn(); return; }
  queue.push({ priority: prio, fn });
}
